module.exports = " <h2>Bank accounts &amp; credit cards</h2> <crud-clerk-account-curate></crud-clerk-account-curate> <div ng-if=restrictUi.byUserType(restrictUi.userTypes.DEVELOPER)> <br/> <h2>Categories</h2> <crud-clerk-account-category-curate></crud-clerk-account-category-curate> </div> ";


//////////////////
// WEBPACK FOOTER
// .-dna/app/subsections/financial-events/inspect.financial-events.accounts.html
// module id = 4158
// module chunks = 86